export default {
    customer:{
        logintitle:'账号登录',
        email:'邮箱',
        password:'密码',
        loginbtn:'登录',
        loginSuccess:'登录成功',
        otherloginMode:'其他登录方式',
        RechargeCore:'充值中心',
        RechargeCores:'充值中心 - U.LU Games',
        AccountsDele:'帐号被删除',
        AccountsSeal:'帐号被封',
        PasswordError:'密码错误',
        AccountsNotence:'账号不存在',
        EmailFormatError:'邮箱格式不正确',
        PlacePassword:'请输入密码',
        PlaceEmail:'请输入邮箱',
        parameterIncomplete:'参数不全',
        Rechargeption:'(充值说明)',
        Rechargeption2:'充值说明',
        obtainGameFail:'游戏获取失败，请重新打开页面',
        placePayMode:'请选择支付方式',
    },
    RechargePage:{
        logout:'登出',
        Rechargeccount:'充值账号',
        game:'游戏',
        TheServer:"服务器",
        RoleNickname:"角色昵称",
        placeChTheSer:"请选择服务器",
        PlaceChNickN:"请选择昵称",
        PayMode:"支付方式",
        ChoosCommodity:"选择商品",
        OrderHathair:"订单未完成",
        HelpConCusSer:"如需帮助，请联系客服 cs@ulugame.com",
        GlobalException:"全局异常",
        good:"好的",
        OrderCompleted:"订单已完成",
        SuccessBuy:"你已成功完成购买",
        Ordercancelled:'订单已取消',
        Databaseerror:"数据库异常",
        operror:"数据库操作异常",
        Invaildlogin:'无效登录，请重新尝试',
        Emailwasbinded:'该邮箱账号已绑定过',
        Codeerror:'验证码错误',
        bindedalready:'该第三方账号已绑定过',
        ULUaccount:"该账号已经绑定了ULU账号",
        Codeinvalid:'验证码已失效',
        haveRegist:"账号已注册，请前往登录",
        Requestfrequently:"请求太频繁，请稍后再试",
        notRegister:"未注册",
        oneBind:"解绑所有第三方渠道前，请先绑定一个邮箱",
        idError:"账号错误，请输入正确的解绑账号",
        Noorvicnleund:'未查到区服和角色',
        gamesempty:'游戏为空',
        determin:'确定',
        Rechargeonfirmation:'充值确认',
        Confirmwingarormation:'请确认以下充值信息。',
        BuyGoods:'购买商品',
        cancel:'取消',
        RoleNickID:'角色ID',
        PlaceNickID:'请输入角色ID',
        check:'校验',
        PlaceCheckID:'请先校验角色ID',
        CheckSuccess:'校验成功，角色名为:',
        VerificationFailed:'校验失败，角色不存在',
        SystemError:'系统错误',
        InterfaceException:'接口异常',
        FrequentVisits:'访问过于频繁',
        NetworkAnomaly:'网络异常',
        PleLoginFirst:'请先登录游戏账号',
        RecharRoleInformation:'充值角色信息',
        TotalAmount:'总金额',
        ImmediatePayment:'立即支付',
        PleaseVerifyServer:'请校验服务器',
        PayRole:'充值角色',
        PlsselectRole:'请选择角色',

        // 新增
        NoorvicnleundPleaseCreate:'未查询到角色，请先前往游戏创建角色',
        CommoditySettlement:'商品结算',
        TopupRole:'充值角色',
        Server:'服务器',
        product:'商品',
        Price:'价格',
        quantity:'数量',
        Limited:'限购',
        favorable:'优惠',
        SelectCoupon:'选择优惠券',
        NoCouponsAvailable:'没有可用的优惠券',
        PaymentMethod:'支付方式',
        total:'合计',
        CompleteThePayment:'完成付款，预计将获得',
        points:'积分',
        ImmediatePaymentNew:'立即支付',
        BuyNow:'立即购买',
        UserTermsOfService:'用户服务条款',
        PrivacyPolicy:'隐私政策',
        AboutUs:'关于我们',
        full:'满',
        ThePurchaseLimitOtherItems:'已达到购买上限，看看其他商品吧',
        InTheQuery:'查询中',

        expire:'到期',

        placeChTheRole:'请选择角色',
    },
}
